import * as Yup from 'yup';

export const validationSchemaTicket = Yup.object().shape({
  ownerId: Yup.string().required('Ticket Owner is required'),

  subject: Yup.string().required('Subject is required'),
});
